import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
    static targets = ["datePicker"];

    connect() {
        flatpickr(this.datePickerTarget, {
            enableTime: true,
            dateFormat: "Y-m-d H:i",
            onClose: this.shouldAutoSubmit() ? this.submitForm.bind(this) : () => {}
        });
    }

    shouldAutoSubmit() {
        return this.datePickerTarget.dataset.autoSubmit !== 'false';
    }

    submitForm() {
        const form = this.element.closest("form");
        const url = new URL(window.location.href);

        if (url.searchParams.has("page")) {
            form.querySelector("[name='page']").value = url.searchParams.get("page");
        }

        form.requestSubmit();
    }
}
